import { render, staticRenderFns } from "./Package_Add_Items.vue?vue&type=template&id=7857074e&"
import script from "./Package_Add_Items.vue?vue&type=script&lang=js&"
export * from "./Package_Add_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports